import React, { useState, useEffect, useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  IconButton,
  Badge,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../Dashboard/Dashboard';
import ExpenseList from '../Expense/ExpenseList';
import UserDetailsContext from '../Dashboard/UserDetailsContext';
import { Delete } from '@mui/icons-material';
import axios from 'axios';
import { useExpenseStore } from '../store/useExpenseStore';
import ExpenseForm from '../Expense/ExpenseForm';
import { Home, FileText, CheckSquare, Package, ShoppingCart, Building2 } from "lucide-react"
import { useLocation } from 'react-router-dom';
import UseFeatureFlags from '../components/UseFeatureFlags';
import {
  // ... existing imports
  Menu,
  MenuItem,
  Avatar,
  Divider,
} from '@mui/material';
import { Person, ExitToApp } from '@mui/icons-material';


export default function AdminDashboard() {
  const [comment, setComment] = useState('');
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [expenses, setExpenses] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openExpenseForm, setOpenExpenseForm] = useState(false);
  const navigate = useNavigate();
  const [showAddForm, setShowAddForm] = useState(false);
  const userDetails = useContext(UserDetailsContext);
  const [catcount, setCatCount] = useState(0);
  const [expen, setExpense] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true); // <-- Add loading state
  const [showActionBar, setShowActionBar] = useState(true); // Track action bar visibility
  const {  hasFeature } = UseFeatureFlags();
  const expenseStore = useExpenseStore();
  const [anchorEl, setAnchorEl] = useState(null);
const [showProfileDetails, setShowProfileDetails] = useState(false);


  
  // Debug feature flags
  console.log('Feature flags:', {
    add_expense: hasFeature('add_expense'),
    review_expense: hasFeature('review_expense')
  });


  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

    const token =
      urlParams.get("token") ||
      urlParams.get('deviceToken') ||
      localStorage.getItem("token");
    console.log("Extracted Token    9999:", token);
  const buildPOUrl = (path) => token ? `${path}?token=${token}` : path;
  
 const handleMenuOpen = (event) => {
    event.stopPropagation();
  setAnchorEl(event.currentTarget);
};

const handleMenuClose = () => {
  setAnchorEl(null);
};

  const handleHeaderClick = () => {
    if (anchorEl) {
      handleMenuClose();
    }
  };

const handleSignOut = () => {
navigate('/signin');
  console.log('Signing out...');
  handleMenuClose();
};

  useEffect(() => {
    if (!token) {
      window.location.href = 'https://accounts.aurumi.ai';
    }
  }, [token]);



  useEffect(() => {
    let isMounted = true;
    async function fetchAll() {
      setLoading(true);
      const bId = userDetails?.userDetails?.BusinessID;
      const tId = userDetails?.userDetails?.TeamContactID;
      if (bId) {
        await Promise.all([
          expenseStore.loadExpensesByTeamContact(tId),
          expenseStore.loadCategoriesByBusiness(bId),
        ]);
        if (!isMounted) return;
        const store = useExpenseStore.getState();
        setExpenses(store.getTeamExpenses(tId));
        setCatCount(store.getCategories(bId).length);
        setExpense(store.getTeamExpenses(tId).length);
      }
      if (isMounted) setLoading(false);
    }
    fetchAll();
    return () => { isMounted = false; }
  }, [userDetails]);

  // Handle scroll events for action bar visibility
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateActionBarVisibility = () => {
      const currentScrollY = window.scrollY;
      
      // Show action bar when at top, hide when scrolling down
      if (currentScrollY <= 10) {
        setShowActionBar(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowActionBar(false);
      } else if (currentScrollY < lastScrollY && currentScrollY < 50) {
        setShowActionBar(true);
      }
      
      lastScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateActionBarVisibility);
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchExpenses = async (businessID) => {
    const tId = userDetails?.userDetails?.TeamContactID;
    await expenseStore.loadExpensesByTeamContact(tId, { force: true });
    const store = useExpenseStore.getState();
    const list = store.getTeamExpenses(tId);
    setExpenses(list);
    setExpense(list.length);
  };

  const fetchCategories = async (businessID) => {
    const bId = userDetails?.userDetails?.BusinessID;
    await expenseStore.loadCategoriesByBusiness(bId, { force: true });
    const list = useExpenseStore.getState().getCategories(bId);
    setCategories(list);
    setCatCount(list.length);
  };

  const handleExpenseAction = (expense, action) => {
    setSelectedExpense({ ...expense, action });
    setOpenDialog(true);
  };

  const handleSubmitAction = async () => {
    try {
      const { ExpenseID, TeamContactID, action } = selectedExpense;

      const updatedExpense = await expenseStore.reviewExpense({
        ExpenseID,
        TeamContactID,
        Status: action.toUpperCase(),
        Comment: comment,
        BusinessID: userDetails?.userDetails?.BusinessID,
        UserRole: userDetails?.userDetails?.UserRole,
      });

      // Refresh local view
      const tId = userDetails?.userDetails?.TeamContactID;
      setExpenses(useExpenseStore.getState().getTeamExpenses(tId));

      handleCloseDialog();
    } catch (error) {
      console.error('Error updating expense:', error);
      alert('Failed to update expense status');
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setComment('');
    setSelectedCategory(null);
  };

  const handleAddCategory = async () => {
    if (!comment || !userDetails?.BusinessID) {
      alert('Please enter a category and ensure BusinessID is available.');
      return;
    }

    try {
      await expenseStore.addCategory({ CategoryName: comment.toUpperCase(), BusinessID: userDetails.BusinessID });

      alert('Category added successfully!');
      setComment('');
      fetchCategories(userDetails.BusinessID);
    } catch (error) {
      console.error('Error adding category:', error);
      alert('Failed to add category.');
    }
  };

  const handleDeleteCategory = async (category) => {
    if (!category) return;

    try {
      await expenseStore.deleteCategory({ CategoryID: category.ID, BusinessID: userDetails?.userDetails?.BusinessID });
      setCategories(useExpenseStore.getState().getCategories(userDetails?.userDetails?.BusinessID));
      setCatCount((prev) => Math.max(0, prev - 1));
      alert('Category deleted successfully!');
    } catch (error) {
      console.error('Error deleting category:', error);
      alert('Failed to delete category.');
    }
  };


  // --- UI section ---
  return (
    <>
      {/* AppBar */}
    <AppBar
  position="sticky"
  className="bg-white"
  sx={{
       top: 0,
    zIndex: 1400, // Highest z-index
    display: {
      xs: 'none',
      sm: 'block',
    },
  }}
>
  <Toolbar
    onClick={handleHeaderClick}
    sx={{
      display: 'flex',
      flexDirection: { sm: 'row' },
      alignItems: { sm: 'center' },
      justifyContent: 'space-between',
      gap: 1,
      width: '100%',
    }}
  >
    {/* Left Section: Logo + Title */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <img
        src="./../AurumiLogo.png"
        alt="Aurumi Logo"
        width="28"
        height="28"
        className="rounded-circle"
      />
  <Typography variant="h6" sx={{ color: 'black', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1 }}>
  Expense Manager
  <Typography variant="caption" sx={{ fontSize: '0.7rem', mt: 0.5 }}>
    {userDetails?.userDetails?.BusinessName || 'Business'}
    
  </Typography>
</Typography>
      
    </Box>

    {/* Right Section: Business Name (badge) + User Profile Dropdown */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
        mt: { sm: 0 },
      }}
    >
      <Typography
        sx={{
         mt: { sm: 1 },
        }}
      >
        <h5 className="hidden md:block text-lg font-medium">Welcome,{userDetails?.userDetails?.UserName || 'User'}</h5>
      </Typography>

      <Button
        onClick={handleMenuOpen}
        sx={{
          minWidth: 'auto',
          p: 0,
          borderRadius: '50%',
        }}
      >
        <Avatar
          sx={{
            bgcolor: 'primary.main',
            width: 36,
            height: 36,
          }}
        >
          {userDetails?.userDetails?.UserName?.split(' ').map(word => word[0]?.toUpperCase()).join('').slice(0, 2) || 'U'}
        </Avatar>
      </Button>
      

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <Avatar /> {userDetails?.userDetails?.UserName}
        </MenuItem>
        <MenuItem>
          <Typography variant="body2" color="text.secondary">
            {userDetails?.userDetails?.EmailID || 'No email'}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => setShowProfileDetails(prev => !prev)}>
          <Person fontSize="small" sx={{ mr: 1 }} />
          Profile
        </MenuItem>
        {showProfileDetails && (
          <Box sx={{ px: 2, py: 1, fontSize: '0.75rem', color: 'text.secondary' }}>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Business:</strong> {userDetails?.userDetails?.BusinessName || 'N/A'}
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Role:</strong> {userDetails?.userDetails?.UserRole || 'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>Mobile:</strong> {userDetails?.userDetails?.MobileNo || 'N/A'}
            </Typography>
          </Box>
        )}
        <Divider />
        <MenuItem onClick={handleSignOut} sx={{ color: 'error.main' }}>
          <ExitToApp fontSize="small" sx={{ mr: 1 }} />
          Log out
        </MenuItem>
      </Menu>
    </Box>
  </Toolbar>
</AppBar>

               {/* Mobile Navigation Header */}
               {/* Mobile Navigation Header */}
<Box
  sx={{
    display: { xs: 'block', sm: 'none' },
    position: 'sticky',
    top: 0,
    zIndex: 1300,
    backgroundColor: 'white',
    borderBottom: '1px solid #e0e0e0',
    padding: '12px 16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  }}
>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-start', // Changed from 'space-between' to 'flex-start'
      alignItems: 'center',
      gap: 1,
    }}
  >
    <Button
      variant={activeTab === 0 ? "contained" : "outlined"}
      size="small"
      onClick={() => setActiveTab(0)}
      sx={{
        minWidth: 'auto',
        px: 2,
        py: 0.5,
        fontSize: '0.8rem',
        textTransform: 'none',
        height: '36px',
      }}
    >
      Expenses
    </Button>
    <Button
      variant={activeTab === 1 ? "contained" : "outlined"}
      size="small"
      onClick={() => setActiveTab(1)}
      sx={{
        minWidth: 'auto',
        px: 2,
        py: 0.5,
        fontSize: '0.8rem',
        textTransform: 'none',
        height: '36px',
      }}
    >
      Dashboard
    </Button>
  </Box>
</Box>
       


                                                       <Box
        sx={{
          px: 2,
          pt: 2,
             mt: { xs: 0, sm: 0 },
           }}
         >
           {/* Desktop Navigation Tabs */}
           <Box
             sx={{
               display: { xs: 'none', sm: 'block' },
               mb: 2,
             }}
           >
             <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
               <Box sx={{ display: 'flex' }}>
                 <Button
                   variant={activeTab === 0 ? "contained" : "text"}
                   onClick={() => setActiveTab(0)}
                   sx={{
                     px: 4,
                     py: 2,
                     borderRadius: 0,
                     borderBottom: activeTab === 0 ? '3px solid' : 'none',
                     borderColor: 'primary.main',
                     color: activeTab === 0 ? 'primary.main' : 'text.secondary',
                     fontWeight: activeTab === 0 ? 600 : 400,
                     textTransform: 'none',
                     fontSize: '1.1rem',
                     backgroundColor: activeTab === 0 ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                     '&:hover': {
                       backgroundColor: activeTab === 0 ? 'rgba(25, 118, 210, 0.12)' : 'rgba(0, 0, 0, 0.04)',
                     },
                   }}
                 >
                   <FileText sx={{ mr: 1, fontSize: '1.2rem' }} />
                   Expenses
                 </Button>
                 <Button
                   variant={activeTab === 1 ? "contained" : "text"}
                   onClick={() => setActiveTab(1)}
                   sx={{
                     px: 4,
                     py: 2,
                     borderRadius: 0,
                     borderBottom: activeTab === 1 ? '3px solid' : 'none',
                     borderColor: 'primary.main',
                     color: activeTab === 1 ? 'primary.main' : 'text.secondary',
                     fontWeight: activeTab === 1 ? 600 : 400,
                     textTransform: 'none',
                     fontSize: '1.1rem',
                     backgroundColor: activeTab === 1 ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                     '&:hover': {
                       backgroundColor: activeTab === 1 ? 'rgba(25, 118, 210, 0.12)' : 'rgba(0, 0, 0, 0.04)',
                     },
                   }}
                 >
                   <CheckSquare sx={{ mr: 1, fontSize: '1rem' }} />
                   Dashboard
                 </Button>
               </Box>
             </Box>
           </Box>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="60vh"
            width="100%"
          >
            <CircularProgress color="primary" />
            <Typography variant="body1" mt={2}>
              Loading...
            </Typography>
          </Box>
        ) : (
          <>
            {(catcount ?? 0) === 0 && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="60vh"
                width="100%"
              >
                <Typography
                  variant="h6"
                  fontWeight={500}
                  mb={3}
                  align="center"
                  color="text.primary"
                >
                  To Create a Expense, you first need to create Category.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() =>
                    navigate(buildPOUrl(
                      `/manage-categories`
                    ))
                  }

                  sx={{ minWidth: 140,textTransform: 'none',
                       fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                >
                  Add Category
                </Button>
              </Box>
            )}
            {(catcount ?? 0) !== 0 && (expen ?? 0) === 0 && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="60vh"
                width="100%"
              >
                <Typography
                  variant="h6"
                  fontWeight={500}
                  mb={3}
                  align="center"
                  color="text.primary"
                >
                  Now You Need To Create Expense.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"

                  onClick={() =>
                    navigate(buildPOUrl(`/expenseform`))
                  }
                  sx={{ minWidth: 180,textTransform: 'none',
                       fontSize: { xs: '0.75rem', sm: '0.875rem' }, }}
                >
                  Create Expense
                </Button>
              </Box>
            )}
          </>
        )}
      </Box>

      {/* Only show main content if both categories & expenses exist and not loading */}
      {!loading && (catcount ?? 0) !== 0 && (expen ?? 0) !== 0 && (
        <Box>
          {activeTab === 0 && (
            <>
              {/* Sticky Action Bar */}
                                                  <Box
                   sx={{
                     position: 'sticky',
                     top: { xs: 65, sm: 64 }, // Match AppBar height
                     zIndex: 1200, // Lower than AppBar
                     backgroundColor: 'white',
                     borderBottom: '1px solid #e0e0e0',
                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                     
                     // ...other styles...
                   }}
                 >
                 {/* <Typography 
                   variant="h5" 
                   sx={{ 
                     fontSize: { xs: '1.25rem', sm: '1.5rem' },
                     fontWeight: 500,
                     mb: { xs: 1, sm: 0 }
                   }}
                 >
                   
                 </Typography> */}
                 <Box sx={{ 
                   display: 'flex', 
                   gap: { xs: 0.5, sm: 1 },
                   flexDirection: { xs: 'row', sm: 'row' },
                   flexWrap: 'wrap'
                 }}>
                  <Button
                  
                    variant="contained"
                    onClick={() =>navigate(buildPOUrl(`/expenseform`))}
                    className='bg-primary '
                     size="small"
                     sx={{
                      textTransform: 'none',
                       fontSize: { xs: '0.75rem', sm: '0.875rem' },
                       px: { xs: 1.5, sm: 2 },
                       py: { xs: 0.5, sm: 1 },
                       minWidth: { xs: 'auto', sm: 'auto' }
                     }}
                  >
                    Add Expense
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => navigate(buildPOUrl(`/approve`))}
                    className='bg-primary'
                     size="small"
                     sx={{
                       textTransform: 'none',
                       fontSize: { xs: '0.75rem', sm: '0.875rem' },
                       px: { xs: 1.5, sm: 2 },
                       py: { xs: 0.5, sm: 1 },
                       minWidth: { xs: 'auto', sm: 'auto' }
                     }}
                  >
                    Review Expense
                  </Button>
                </Box>
              </Box>

                             <Box sx={{ marginTop: '0' }}>
              <ExpenseList
                expenses={expenses}
                isAdmin={true}
                onApprove={(expense) => handleExpenseAction(expense, 'APPROVE')}
                onReject={(expense) => handleExpenseAction(expense, 'REJECT')}
              />
               </Box>
            </>
          )}

          {activeTab === 1 && (
            <Box className="dashboard-container">
              <Dashboard
                expenses={expenses}
                isAdmin={true}
                onApprove={(expense) => handleExpenseAction(expense, 'APPROVE')}
                onReject={(expense) => handleExpenseAction(expense, 'REJECT')}
              />
            </Box>
          )}
        </Box>
      )}

      {/* Manage Categories Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Manage Categories</DialogTitle>
        <DialogContent>
          <Box className="category-form-container">
            <TextField
              fullWidth
              label="Enter Category Name"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              margin="normal"
            />
            <Button
              onClick={handleAddCategory}
              variant="contained"
               sx={{
                       textTransform: 'none',
                       fontSize: { xs: '0.75rem', sm: '0.875rem' },}}
            >
              Add
            </Button>
          </Box>

          <Typography className="page-header-bg">
            Existing Categories
          </Typography>
          <Box className="category-list-container">
            {categories.map((category) => (
              <Box
                key={category.ID}
                className="category-list-item"
              >
                <Typography variant="body1">{category.Category}</Typography>
                <IconButton
                  color="error"
                  onClick={() => handleDeleteCategory(category)}
                >
                  <Delete />
                </IconButton>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Add Expense Dialog */}
      <Dialog
        open={openExpenseForm}
        onClose={() => setOpenExpenseForm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Expense</DialogTitle>
        <DialogContent>
          <ExpenseForm
            onSubmit={() => {
              setOpenExpenseForm(false);
              if (userDetails?.BusinessID) {
                fetchExpenses(userDetails.BusinessID);
              }
            }}
            onCancel={() => setOpenExpenseForm(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}